<div class="container">
  <h3>{{ profile?.name }}</h3>
  <div class="lineInfo">
    <p [innerHTML]="profile?.wysiwygEditorContent" id="tinymce"></p>
  </div>
</div>
@if (button) {
  <button mat-raised-button color="primary" (click)="close()" matRipple>
    {{ 'INTERFACE|Wybierz' | translate }}
  </button>
}
